import React from "react";
import Input from "nekrasovka-ui/Input";
import { connect } from "react-redux";
import styled from "styled-components";

import search from "modules/search";
import persons from "modules/persons";
import { withRouter } from "react-router-dom";

const { queryUpdate, fetchSearch } = search.actions;
const { clearPersons } = persons.actions;

const SearchContainer = styled.div`
  @media (max-width: 568px) {
    margin-top: 30px;
  }
`;

const StyledInput = styled(Input)`
  height: 55px;

  @media (max-width: 768px) {
    & {
      height: 35px;

      & > button {
        display: flex;

        & svg {
          height: 16px;
          width: 16px;
        }
      }
    }
  }
`;

const Search = ({
  queryUpdate,
  clearPersons,
  fetchSearch,
  letter,
  query,
  history,
  history: {
    location: { pathname },
  },
}) => {
  const handleChange = (query) => {
    if (query.target.value) {
      pathname !== "/search" && history.push("/search");
    } else {
      history.push("/");
    }

    queryUpdate(query.target.value);

    if (query.target.value.length > 1) {
      fetchSearch(query.target.value);
    } else {
      if (letter !== "") clearPersons();
    }
  };

  return (
    <SearchContainer ref={(target) => (this.input = target)}>
      <StyledInput
        value={query}
        onChange={handleChange}
        placeholder="Введите имя или описание персоны"
        icon="search"
        heightIcon={30}
      />
    </SearchContainer>
  );
};

const mapStateToProps = ({ search: { query }, persons: { letter } }) => ({
  query,
  letter,
});

export default withRouter(
  connect(mapStateToProps, { queryUpdate, fetchSearch, clearPersons })(Search)
);



// WEBPACK FOOTER //
// ./src/containers/Search/index.js